// extracted by mini-css-extract-plugin
export var text = "_ab-0";